
@if ({versionHistory: versionHistory$ | async }; as vm) {
  <div class="course-heading mb-4 flex items-center justify-between gap-4">
    @if (course) {
      <div class="course-details">
        <h3 class="mb-3 text-neutral-800">{{ course.title }}</h3>
        <div class="course-meta inline-flex items-center gap-[10px] text-sm">
          <div class="category">{{ course.category_name }}</div>
          <svg-icon class="h-[10px] w-[10px] text-neutral-300" src="@assets/images/icons/dot.svg"></svg-icon>
          <div class="last-update text-neutral-600">
            Last edited <span class="font-semibold">{{ course.date_updated | date }}</span>
          </div>
          <svg-icon class="h-[10px] w-[10px] text-neutral-300" src="@assets/images/icons/dot.svg"></svg-icon>
          <div (ClickOutside)="handleClickOutside(1)" class="relative">
            <div class="dropdown-container">
              <span (click)="showVersionAction()"> Showing Version </span>
              <span> <b>v{{course.version}}</b> </span>
              <svg-icon (click)="dropdown(1)" class="h-6 w-6 text-neutral-300" src="@assets/images/icons/chevron-down-solid.svg"></svg-icon>
            </div>
            <div [class]="isDropdown[1] ? 'flex':'hidden'" class="dropdown-items">
              @for (history of vm.versionHistory?.history; track history) {
                <span (click)="switchVersion(history, 1)">v{{history.version}}</span>
              }
            </div>
          </div>
          <svg-icon class="h-[10px] w-[10px] text-neutral-300" src="@assets/images/icons/dot.svg"></svg-icon>
          @if (course.is_latest) {
            <div class="bg-blue-600 px-3 py-1 text-xs text-blue-100 rounded-md">Latest</div>
          }
          @if (course.is_current) {
            <div class="bg-slate-900 px-3 py-1 text-xs text-blue-100 rounded-md">Current</div>
          }
          <div class="status">
            @if (course.status === 'published') {
              <div class="border border-green-300 bg-green-100 rounded-md text-green-700 px-3 py-1 text-xs flex items-center gap-1">
                <span class="w-2 h-2 bg-green-500 rounded-full"></span>
                Published
              </div>
            }
            @if (course.status === 'in_review') {
              <div class="border border-amber-300 bg-amber-100 rounded-md text-amber-700 px-3 py-1 text-xs flex items-center gap-1">
                <span class="w-2 h-2 bg-amber-500 rounded-full"></span>
                In Review
              </div>
            }
            @if (course.status === 'draft') {
              <div class="border border-slate-300 bg-slate-100 rounded-md text-slate-700 px-3 py-1 text-xs flex items-center gap-1">
                <span class="w-2 h-2 bg-slate-500 rounded-full"></span>
                Draft
              </div>
            }
            @if (course.status === 'rejected') {
              <div class="border border-red-300 bg-red-100 rounded-md text-red-700 px-3 py-1 text-xs flex items-center gap-1">
                <span class="w-2 h-2 bg-red-500 rounded-full"></span>
                Rejected
              </div>
            }
            <!-- <div *ngIf="course.status === 'rejected'" class="tag tag-{{ getStatusTagColor(course.status) }} tag-sm">
            Rejected
          </div> -->
        </div>
      </div>
    </div>
  }
  <div class="actions">
    <ng-content select="[actions]"></ng-content>
  </div>
</div>
}